import React, { Component } from 'react'
import Helping from '../../helpers/Helping'
import Notification from '../layout/Notification'
import Pagination from 'react-js-pagination'
import { MESSAGE } from '../../config/index'
import { API_URL } from '../../config/urls'
import Service from '../../helpers/service'
import { connect } from 'react-redux'
import { setProfileError, addCurrentRoute } from '../../actions/profile_action'
import { trackPromise } from 'react-promise-tracker'
import LoadingButton from '../fields/LoadingButton'
import Filter from '../layout/Filter'
import { Link } from "react-router-dom"
import { DETAIL_USER } from '../../config/routes'

const { NOT_FOUND } = MESSAGE
class List extends Component {
    constructor(props) {
        super(props)

        this.state = {
            users: [],
            routeName: '',
            error_message: '',
            error_type: '',
            isLoading: true,
            total: 0,
            status: '',
            activePage: 1,
            no_Of_pages: 1,
            limit: 10,
            search: '',
            sorting: 'id',
            sort_type: 'DESC',
            is_order: false,
            btnIsDisable: false,
            reward_id: ''
        }

        this.handlePageChange = this.handlePageChange.bind(this)
        this.handleSearchChange = this.handleSearchChange.bind(this)
        this.handleLimitChange = this.handleLimitChange.bind(this)
        this.pageRefreshFunction = this.pageRefreshFunction.bind(this)
        this.sortBy = this.sortBy.bind(this)
    }

    setErrorOnApiCall = () => {
        setProfileError(res => this.setState({ ...res }))
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest() })
    }

    componentDidMount() {
        const { pathname } = this.props.location
        this.setState({
            routeName: pathname
        })

        this.props.addCurrentRoute(this.props.profile, pathname)
        this.setErrorOnApiCall()
        this.getUsersRewards()
    }

    getUsersRewards = () => {
        let { search, activePage, sorting, sort_type, limit, status } = this.state
        let params = `page=${activePage}&limit=${limit}&search=${search}&sorting=${sorting}&sort_type=${sort_type}&status=${status}`

        trackPromise(
            Service.getCall(API_URL.ADMIN_COLLECTION_API + 'user-reward-list?' + params, Helping.getConfig())
                .then(response => {
                    let { message } = response.data

                    this.setState({
                        users: message.reward_user,
                        total: message.total,
                        no_Of_pages: Math.ceil(message.total / limit),
                        isLoading: false,
                        error_type: "",
                        error_message: ""
                    })
                })
                .catch(error => {
                    if (error.response) {
                        Helping.redirectToLogin(error)
                        return this.setState({
                            error_message: error.response.data.message,
                            error_type: 'danger',
                            users: [],
                            total: 0,
                            no_Of_pages: 0,
                        },
                            () => this.scrollToTop())
                    }
                    return this.setState({
                        ...Helping.setNetworkRequestError(error, "fetching rewards users")
                    })
                })
        )
    }

    pageRefreshFunction(e) {
        // e.preventDefault()

        this.setState({
            search: "",
            activePage: 1,
            status: "",
            error_message: "",
            error_type: ""
        },
            () => this.getUsersRewards())
    }

    openConfirmationModal = (e, object) => {
        this.setState({ reward_id: object.id })
    }

    closeConfirmationModal = () => {
        window.$('#sendRewardModal').modal('hide')
    }

    scrollToTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        })
    }

    handlePageChange(pageNumber) {
        if (this.state.activePage === pageNumber) {
            return false
        }

        this.setState({
            activePage: pageNumber,
            isLoading: true
        },
            () => this.getUsersRewards())
    }

    handleLimitChange(itemsLimit) {
        if (this.state.limit === itemsLimit) {
            return false
        }
        this.setState({
            limit: itemsLimit,
            activePage: 1,
            isLoading: true
        },
            () => this.getUsersRewards())
    }

    handleSearchChange(e) {
        let $this = this,
            searchValue = e.target.value.replace(/^\s+/g, '')

        if (this.state.search !== searchValue) {
            this.setState({
                search: searchValue,
                activePage: 1
            }, () => {
                if (searchValue.length > 0) {
                    $this.getUsersRewards()
                }

                if (searchValue.length === 0) {
                    $this.getUsersRewards()
                }
            })
        }
    }

    sortBy(key) {
        let $this = this
        let sortType = this.state.sort_type

        if (this.state.sort_type === 'ASC') {
            sortType = 'DESC'
        }

        if (this.state.sort_type === 'DESC') {
            sortType = 'ASC'
        }

        this.setState({
            sorting: key,
            activePage: 1,
            is_order: true,
            sort_type: sortType
        }, () => {
            $this.removeNetworkError()
            $this.getUsersRewards()
        })
    }

    updateStatus(id, status) {
        let self = this

        Service.postCall(API_URL.ADMIN_COLLECTION_API + 'update-reward-status', {
            user_reward_id: id,
            status: status
        }, Helping.getConfig())
            .then(response => {
                self.pageRefreshFunction()
            })
            .catch(error => {
                if (error.response) {
                    Helping.redirectToLogin(error)
                    return this.setState({
                        error_message: error.response.data.message,
                        error_type: 'danger',
                        reward_id: ''
                    }, () => this.scrollToTop())
                }
                return this.setState({
                    ...Helping.setNetworkRequestError(error, "fetching rewards users")
                })
            })
    }

    sendReward = () => {
        let self = this
        self.setState({
            btnIsDisable: true
        })

        let data = {
            reward_id: this.state.reward_id
        }
        console.log(data)
        Service.postCall(API_URL.ADMIN_TRADING_API + 'reward-transaction', data, Helping.getConfig())
            .then(response => {
                self.setState(
                    {
                        error_message: 'Reward Transaction created successfully.',
                        error_type: "success",
                        btnIsDisable: false
                    }, () => { this.closeConfirmationModal(); this.scrollToTop() }
                )
                self.updateStatus(this.state.reward_id, "processing")
            })
            .catch(error => {
                if (error.response) {
                    Helping.redirectToLogin(error)
                    return this.setState({
                        error_message: error.response.data.message,
                        error_type: 'danger',
                        btnIsDisable: false
                    }, () => { this.closeConfirmationModal(); this.scrollToTop() })
                }
                return this.setState({
                    ...Helping.setNetworkRequestError(error, "fetching rewards users")
                })
            })
    }

    filteredResults = (e) => {
        e.preventDefault();
        this.setState({
            activePage: 1
        }, () => this.getUsersRewards())
    }

    render() {
        const data = {
            inputs: [{
                type: 'dropdown',
                label: 'Status',
                name: 'status',
                defaultValue: this.state.status,
                placeholder: 'Select Status...',
                data: [{ "name": 'pending', "value": 'pending' }, { "name": 'processing', "value": 'processing' }, { "name": 'claimed', "value": 'claimed' }, { "name": 'success', "value": 'success' }, { "name": 'expired', "value": 'expired' }]
            }],
            handleValueChange: (e) => this.setState({ status: e.target.value }),
            reset: this.pageRefreshFunction,
            getResults: this.filteredResults
        },
            filtersArray = [this.state.status]

        return (
            <>
                <div class="content user-list">
                    <div class="top-header">
                        <div class="header-title">
                            <h2 class="title">User's Rewards</h2>
                            <span class="title-caption">You have total {this.state.total} rewards users.</span>

                            {/*  SEARCH BAR  */}
                            <form class="listing-search-form" onSubmit={(e) => e.preventDefault()}>
                                <span class="search-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17.999" viewBox="0 0 18 17.999">
                                        <path id="search_Icon" data-name="search Icon" d="M9.583,2a7.579,7.579,0,1,0,4.644,13.56l4.159,4.155a.944.944,0,0,0,1.337.011.973.973,0,0,0,0-1.361L15.56,14.228A7.567,7.567,0,0,0,9.583,2Zm0,1.895A5.684,5.684,0,1,1,3.895,9.579,5.684,5.684,0,0,1,9.579,3.895Z" transform="translate(-2 -2)" />
                                    </svg>
                                </span>
                                <input class="form-control" type="search" placeholder="Search in User Rewards" aria-label="Search" value={this.state.search} onChange={(e) => this.handleSearchChange(e)} />
                            </form>
                            {/*  SEARCH BAR END  */}
                        </div>

                        <div class="header-btn">
                            <Filter data={data} classes={filtersArray.filter(arr => arr != "").length > 0 ? "filtered" : ""} />

                            <button class="custom-btn icon-btn dark-btn sm-btn" onClick={this.pageRefreshFunction}>
                                <svg id="refresh" xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20">
                                    <path id="Path_449" data-name="Path 449" d="M313.164,391.557c-.048-.293-.092-.582-.142-.871a1.127,1.127,0,0,1,.858-1.384,1.064,1.064,0,0,1,1.23.963q.326,1.894.628,3.794a1.1,1.1,0,0,1-.933,1.327l-3.615.643a1.065,1.065,0,0,1-1.262-.888,1.1,1.1,0,0,1,.854-1.288c.438-.095.882-.163,1.378-.252-.108-.068-.173-.113-.242-.151a6.869,6.869,0,0,0-10.015,5.356,7.187,7.187,0,0,0,5.554,8.138,6.961,6.961,0,0,0,8.137-5.977,1.081,1.081,0,0,1,1-.984,1.024,1.024,0,0,1,1.063.8,2.485,2.485,0,0,1-.027.9,9.223,9.223,0,0,1-7.31,7.461,9.074,9.074,0,0,1-10.447-7.421,9.412,9.412,0,0,1,7.2-11.144,8.62,8.62,0,0,1,5.859.9c.053.028.1.056.158.082A.241.241,0,0,0,313.164,391.557Z" transform="translate(-299.689 -389.283)" />
                                </svg>
                                <span class="txt-btn">Refresh</span>
                            </button>
                        </div>
                    </div>

                    <div class="main-content">
                        {this.state.error_message &&
                            <Notification
                                type={this.state.error_type}
                                message={this.state.error_message}
                                callback={this.removeNetworkError}
                            />
                        }
                        <div class="collection-listing table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="tbl-sorting" scope="col" onClick={() => this.sortBy('id')}>
                                            ID
                                            <span class={`icon ascending ${this.state.sort_type === 'ASC' && this.state.sorting === 'id' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.001" viewBox="0 0 16 12.001"><g id="Group_187" data-name="Group 187" transform="translate(-2.475 -12.975)"><g id="Group_186" data-name="Group 186" transform="translate(2.475 12.975)"><path id="Path_420" data-name="Path 420" d="M2.693,22.32l2.425,2.425a.771.771,0,0,0,1.1,0L8.643,22.32a.777.777,0,0,0-1.1-1.1l-1.1,1.1V13.751a.776.776,0,1,0-1.552,0V22.32l-1.1-1.1a.781.781,0,0,0-1.1,0A.8.8,0,0,0,2.693,22.32Z" transform="translate(-2.475 -12.975)" /><path id="Path_421" data-name="Path 421" d="M60.576,79.086h4.543a.776.776,0,0,0,.776-.776.753.753,0,0,0-.776-.76H60.576a.776.776,0,0,0-.776.776A.753.753,0,0,0,60.576,79.086Z" transform="translate(-49.895 -67.11)" /><path id="Path_422" data-name="Path 422" d="M49.023,13H41.376a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h7.647a.776.776,0,0,0,.776-.776A.766.766,0,0,0,49.023,13Z" transform="translate(-33.8 -12.996)" /><path id="Path_423" data-name="Path 423" d="M54.389,34.5H47.776a.776.776,0,0,0,0,1.552h6.613a.776.776,0,0,0,.776-.776A.766.766,0,0,0,54.389,34.5Z" transform="translate(-39.165 -31.02)" /><path id="Path_424" data-name="Path 424" d="M59.754,56H54.176a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h5.578a.776.776,0,0,0,.776-.776A.766.766,0,0,0,59.754,56Z" transform="translate(-44.53 -49.044)" /></g></g></svg></span>
                                            <span class={`icon descending ${this.state.sort_type === 'DESC' && this.state.sorting === 'id' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g id="Group_185" data-name="Group 185" transform="translate(-2.475 -12.975)"><g id="Group_184" data-name="Group 184" transform="translate(2.475 12.975)"><path id="Path_415" data-name="Path 415" d="M8.807,15.63,6.322,13.205a.8.8,0,0,0-1.126,0L2.711,15.63a.758.758,0,0,0,0,1.1.8.8,0,0,0,1.126,0l1.126-1.1V24.2a.8.8,0,0,0,1.59,0V15.63l1.126,1.1a.814.814,0,0,0,1.126,0A.787.787,0,0,0,8.807,15.63Z" transform="translate(-2.475 -12.975)" /><path id="Path_416" data-name="Path 416" d="M60.6,14.574h4.654a.8.8,0,0,0,.8-.8.771.771,0,0,0-.8-.778H60.6a.8.8,0,0,0-.8.8A.771.771,0,0,0,60.6,14.574Z" transform="translate(-50.045 -12.996)" /><path id="Path_417" data-name="Path 417" d="M49.23,77.5H41.4a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H49.23a.8.8,0,0,0,.8-.8A.785.785,0,0,0,49.23,77.5Z" transform="translate(-34.025 -67.107)" /><path id="Path_418" data-name="Path 418" d="M54.57,56H47.8a.8.8,0,0,0,0,1.59H54.57a.8.8,0,0,0,.8-.8A.785.785,0,0,0,54.57,56Z" transform="translate(-39.365 -49.069)" /><path id="Path_419" data-name="Path 419" d="M59.91,34.5H54.2a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H59.91a.8.8,0,0,0,.8-.8A.785.785,0,0,0,59.91,34.5Z" transform="translate(-44.705 -31.033)" /></g></g></svg></span>
                                        </th>
                                        <th scope="col">Reward</th>
                                        <th scope="col">Collection</th>
                                        <th scope="col">Code</th>
                                        <th scope="col">Brand</th>
                                        <th scope="col">Type</th>
                                        <th class="tbl-sorting" scope="col" onClick={() => this.sortBy('status')}>
                                            Status
                                            <span class={`icon ascending ${this.state.sort_type === 'ASC' && this.state.sorting === 'status' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.001" viewBox="0 0 16 12.001"><g id="Group_187" data-name="Group 187" transform="translate(-2.475 -12.975)"><g id="Group_186" data-name="Group 186" transform="translate(2.475 12.975)"><path id="Path_420" data-name="Path 420" d="M2.693,22.32l2.425,2.425a.771.771,0,0,0,1.1,0L8.643,22.32a.777.777,0,0,0-1.1-1.1l-1.1,1.1V13.751a.776.776,0,1,0-1.552,0V22.32l-1.1-1.1a.781.781,0,0,0-1.1,0A.8.8,0,0,0,2.693,22.32Z" transform="translate(-2.475 -12.975)" /><path id="Path_421" data-name="Path 421" d="M60.576,79.086h4.543a.776.776,0,0,0,.776-.776.753.753,0,0,0-.776-.76H60.576a.776.776,0,0,0-.776.776A.753.753,0,0,0,60.576,79.086Z" transform="translate(-49.895 -67.11)" /><path id="Path_422" data-name="Path 422" d="M49.023,13H41.376a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h7.647a.776.776,0,0,0,.776-.776A.766.766,0,0,0,49.023,13Z" transform="translate(-33.8 -12.996)" /><path id="Path_423" data-name="Path 423" d="M54.389,34.5H47.776a.776.776,0,0,0,0,1.552h6.613a.776.776,0,0,0,.776-.776A.766.766,0,0,0,54.389,34.5Z" transform="translate(-39.165 -31.02)" /><path id="Path_424" data-name="Path 424" d="M59.754,56H54.176a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h5.578a.776.776,0,0,0,.776-.776A.766.766,0,0,0,59.754,56Z" transform="translate(-44.53 -49.044)" /></g></g></svg></span>
                                            <span class={`icon descending ${this.state.sort_type === 'DESC' && this.state.sorting === 'status' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g id="Group_185" data-name="Group 185" transform="translate(-2.475 -12.975)"><g id="Group_184" data-name="Group 184" transform="translate(2.475 12.975)"><path id="Path_415" data-name="Path 415" d="M8.807,15.63,6.322,13.205a.8.8,0,0,0-1.126,0L2.711,15.63a.758.758,0,0,0,0,1.1.8.8,0,0,0,1.126,0l1.126-1.1V24.2a.8.8,0,0,0,1.59,0V15.63l1.126,1.1a.814.814,0,0,0,1.126,0A.787.787,0,0,0,8.807,15.63Z" transform="translate(-2.475 -12.975)" /><path id="Path_416" data-name="Path 416" d="M60.6,14.574h4.654a.8.8,0,0,0,.8-.8.771.771,0,0,0-.8-.778H60.6a.8.8,0,0,0-.8.8A.771.771,0,0,0,60.6,14.574Z" transform="translate(-50.045 -12.996)" /><path id="Path_417" data-name="Path 417" d="M49.23,77.5H41.4a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H49.23a.8.8,0,0,0,.8-.8A.785.785,0,0,0,49.23,77.5Z" transform="translate(-34.025 -67.107)" /><path id="Path_418" data-name="Path 418" d="M54.57,56H47.8a.8.8,0,0,0,0,1.59H54.57a.8.8,0,0,0,.8-.8A.785.785,0,0,0,54.57,56Z" transform="translate(-39.365 -49.069)" /><path id="Path_419" data-name="Path 419" d="M59.91,34.5H54.2a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H59.91a.8.8,0,0,0,.8-.8A.785.785,0,0,0,59.91,34.5Z" transform="translate(-44.705 -31.033)" /></g></g></svg></span>
                                        </th>
                                        <th class="tbl-sorting" scope="col" onClick={() => this.sortBy('created_at')}>
                                            Created at
                                            <span class={`icon ascending ${this.state.sort_type === 'ASC' && this.state.sorting === 'created_at' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12.001" viewBox="0 0 16 12.001"><g id="Group_187" data-name="Group 187" transform="translate(-2.475 -12.975)"><g id="Group_186" data-name="Group 186" transform="translate(2.475 12.975)"><path id="Path_420" data-name="Path 420" d="M2.693,22.32l2.425,2.425a.771.771,0,0,0,1.1,0L8.643,22.32a.777.777,0,0,0-1.1-1.1l-1.1,1.1V13.751a.776.776,0,1,0-1.552,0V22.32l-1.1-1.1a.781.781,0,0,0-1.1,0A.8.8,0,0,0,2.693,22.32Z" transform="translate(-2.475 -12.975)" /><path id="Path_421" data-name="Path 421" d="M60.576,79.086h4.543a.776.776,0,0,0,.776-.776.753.753,0,0,0-.776-.76H60.576a.776.776,0,0,0-.776.776A.753.753,0,0,0,60.576,79.086Z" transform="translate(-49.895 -67.11)" /><path id="Path_422" data-name="Path 422" d="M49.023,13H41.376a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h7.647a.776.776,0,0,0,.776-.776A.766.766,0,0,0,49.023,13Z" transform="translate(-33.8 -12.996)" /><path id="Path_423" data-name="Path 423" d="M54.389,34.5H47.776a.776.776,0,0,0,0,1.552h6.613a.776.776,0,0,0,.776-.776A.766.766,0,0,0,54.389,34.5Z" transform="translate(-39.165 -31.02)" /><path id="Path_424" data-name="Path 424" d="M59.754,56H54.176a.776.776,0,0,0-.776.776.766.766,0,0,0,.776.776h5.578a.776.776,0,0,0,.776-.776A.766.766,0,0,0,59.754,56Z" transform="translate(-44.53 -49.044)" /></g></g></svg></span>
                                            <span class={`icon descending ${this.state.sort_type === 'DESC' && this.state.sorting === 'created_at' ? 'active' : ''}`}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"><g id="Group_185" data-name="Group 185" transform="translate(-2.475 -12.975)"><g id="Group_184" data-name="Group 184" transform="translate(2.475 12.975)"><path id="Path_415" data-name="Path 415" d="M8.807,15.63,6.322,13.205a.8.8,0,0,0-1.126,0L2.711,15.63a.758.758,0,0,0,0,1.1.8.8,0,0,0,1.126,0l1.126-1.1V24.2a.8.8,0,0,0,1.59,0V15.63l1.126,1.1a.814.814,0,0,0,1.126,0A.787.787,0,0,0,8.807,15.63Z" transform="translate(-2.475 -12.975)" /><path id="Path_416" data-name="Path 416" d="M60.6,14.574h4.654a.8.8,0,0,0,.8-.8.771.771,0,0,0-.8-.778H60.6a.8.8,0,0,0-.8.8A.771.771,0,0,0,60.6,14.574Z" transform="translate(-50.045 -12.996)" /><path id="Path_417" data-name="Path 417" d="M49.23,77.5H41.4a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H49.23a.8.8,0,0,0,.8-.8A.785.785,0,0,0,49.23,77.5Z" transform="translate(-34.025 -67.107)" /><path id="Path_418" data-name="Path 418" d="M54.57,56H47.8a.8.8,0,0,0,0,1.59H54.57a.8.8,0,0,0,.8-.8A.785.785,0,0,0,54.57,56Z" transform="translate(-39.365 -49.069)" /><path id="Path_419" data-name="Path 419" d="M59.91,34.5H54.2a.8.8,0,0,0-.8.8.785.785,0,0,0,.8.8H59.91a.8.8,0,0,0,.8-.8A.785.785,0,0,0,59.91,34.5Z" transform="translate(-44.705 -31.033)" /></g></g></svg></span>
                                        </th>
                                        <th scope="col">Actions</th>
                                    </tr>
                                </thead>

                                {(this.state.total > 0 && !this.state.isLoading) && (
                                    <tbody>
                                        {this.state.users.map((user, i) => {
                                            let brand = null
                                            if (user.collection.brand_content) {
                                                brand = JSON.parse(user.collection.brand_content)
                                            }

                                            return (
                                                <tr key={i}>
                                                    <td scope="row">{user.id}</td>
                                                    <td>{user.reward ? user.reward.code : null}</td>
                                                    <td><div>{user.collection ? user.collection.name : null}</div></td>
                                                    <td>{user.collection ? user.collection.code : null}</td>
                                                    <td>{brand ? brand.name : null}</td>
                                                    <td class="collection-type">{user.collection ? user.collection.type : null}</td>
                                                    <td class={`status ${user.status === 'success' ? "yes" : user.status === 'pending' ? 'no' : ''}`}>{user.status ? user.status : null}</td>
                                                    <td>{Helping.convertTimeToHumanReadableFormat(user.created_at)}</td>
                                                    <td>
                                                        <div class="action-links">
                                                            <button type="button" class="icon sendRewards"
                                                                title="Send Reward" data-toggle="modal" data-target="#sendRewardModal"
                                                                onClick={(e) => this.openConfirmationModal(e, user)}
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                                    <path id="send_reward" data-name="send reward" d="M19.615,2.438a7.35,7.35,0,0,0-3.1.752L4.033,9.268c-2.326,1.131-2.068,3.3.458,3.857l5.944,1.307,1.307,5.947c.561,2.526,2.724,2.785,3.855.458L21.672,8.353C23.28,4.816,22.221,2.488,19.615,2.438ZM19.19,4.5c1.383-.2,1.588.774.588,2.973l-6.01,12.353-1.437-6.5a1.022,1.022,0,0,0-.784-.784L5.046,11.1l12.38-6.013A6.841,6.841,0,0,1,19.19,4.5Z" transform="translate(-2.433 -2.437)" />
                                                                </svg>
                                                            </button>
                                                            <Link to={DETAIL_USER + user.user_id} class="icon more" title="View User Detail">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16">
                                                                    <path id="view" d="M13.421,8.25a1,1,0,1,1-.688,1.875,2.077,2.077,0,0,0-.72-.125,2,2,0,1,0,2,2,1,1,0,0,1,2,0,3.987,3.987,0,1,1-2.6-3.75Zm6.1-.406a16.737,16.737,0,0,1,1.814,2.562,11.393,11.393,0,0,1,.595,1.188,1.058,1.058,0,0,1,0,.812,11.393,11.393,0,0,1-.595,1.188,16.736,16.736,0,0,1-1.814,2.562A9.8,9.8,0,0,1,12.013,20,9.8,9.8,0,0,1,4.5,16.156a16.744,16.744,0,0,1-1.815-2.562,11.541,11.541,0,0,1-.594-1.188,1.058,1.058,0,0,1,0-.812,11.541,11.541,0,0,1,.594-1.188A16.744,16.744,0,0,1,4.5,7.844,9.8,9.8,0,0,1,12.013,4,9.8,9.8,0,0,1,19.523,7.844ZM6.005,9.156a14.439,14.439,0,0,0-1.564,2.25c-.155.271-.222.411-.313.594.091.183.158.323.313.594a14.439,14.439,0,0,0,1.564,2.25A7.924,7.924,0,0,0,12.013,18a7.924,7.924,0,0,0,6.008-3.156,14.576,14.576,0,0,0,1.564-2.25c.155-.271.222-.411.313-.594-.091-.183-.158-.323-.313-.594a14.576,14.576,0,0,0-1.564-2.25A7.924,7.924,0,0,0,12.013,6,7.924,7.924,0,0,0,6.005,9.156Z" transform="translate(-2.013 -4)" />
                                                                </svg>
                                                            </Link>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                        )}
                                    </tbody>
                                )}
                            </table>
                        </div>

                        {this.state.total > 0 && (
                            <div class="table-bottom">
                                <div class="dataTables_length">
                                    <label>Show
                                        <select
                                            name="userDataTable_length"
                                            value={this.state.limit}
                                            onChange={(e) => this.handleLimitChange(e.target.value)}
                                        >
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select> of {this.state.total}</label>
                                </div>
                                <Pagination
                                    // hideFirstLastPages
                                    activePage={this.state.activePage}
                                    itemsCountPerPage={this.state.limit}
                                    totalItemsCount={this.state.total}
                                    pageRangeDisplayed={5}
                                    onChange={this.handlePageChange}
                                    itemClass='page-item'
                                    linkClass='page-link'
                                    prevPageText='Pre'
                                    nextPageText='Next'
                                    firstPageText='First'
                                    lastPageText='Last'
                                    innerClass="dataTables_paginate"
                                    linkClass="paginate_button"
                                    activeLinkClass="paginate_button current"
                                    disabledClass="paginate_button disabled"
                                />
                            </div>
                        )}

                        {(this.state.total < 1 && !this.state.isLoading) && (
                            <div className="table-responsive">
                                <Notification type="danger"
                                    message={Helping.getMessageString(NOT_FOUND, "Users Rewards")}
                                    callback={this.removeNetworkError} />
                            </div>
                        )}
                    </div>
                </div>

                {/* ----- Send Reward Modal ----- */}
                <div class="actionModal modal fade" id="sendRewardModal" tabindex="-1" role="dialog" aria-labelledby="sendRewardModal" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLongTitle">Confirm Reward Sending</h5>
                            </div>

                            <div class="modal-body">
                                <p class="modal-msg">You are about to send the reward and change status.</p>
                                <p><strong>Do you want to proceed?</strong></p>
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="custom-btn sm-btn semi-dark-btn" data-dismiss="modal">Close</button>

                                {this.state.btnIsDisable ? (
                                    <LoadingButton class_name={"sm-btn"} />
                                ) : (
                                    <button type="button" class="custom-btn sm-btn gradiant-btn" onClick={this.sendReward}>
                                        <span>
                                            {this.state.btnIsDisable ? "Loading..." : "Send Reward"}
                                        </span>
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        profile: state.profile,
        rewards: state.rewards
    }
}

const mapDispatchToProps = {
    addCurrentRoute
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(List)
